import React from "react"

const FieldRenderSubscriberContext = React.createContext<{
  onFieldRendered: (fieldName: string) => void
}>({
  onFieldRendered: () => {},
})
export function FieldRenderSubscriber({
  onFieldRendered,
  children,
}: {
  onFieldRendered: (fieldName: string) => void
  children: React.ReactNode
}) {
  const parentContext = React.useContext(FieldRenderSubscriberContext)
  const combinedOnFieldRendered = React.useCallback(
    (fieldName: string) => {
      onFieldRendered(fieldName)
      parentContext.onFieldRendered(fieldName)
    },
    [onFieldRendered, parentContext],
  )
  return (
    <FieldRenderSubscriberContext.Provider
      value={{ onFieldRendered: combinedOnFieldRendered }}
    >
      {children}
    </FieldRenderSubscriberContext.Provider>
  )
}

export function useFieldRenderNotify(fieldName: string) {
  const context = React.useContext(FieldRenderSubscriberContext)
  const onFieldRendered = React.useEffectEvent(() => {
    context.onFieldRendered(fieldName)
  })
  React.useEffect(() => {
    onFieldRendered()
  }, [])
}
